import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOption, ListOptionRequest } from '../modules/tcm-core.module';

@Injectable({
  providedIn: 'root'
})
export class EdiFiedSetupDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public getDefaultSql(fieldName: string, cancellationToken: Promise<any>): Promise<string> {
    return this.httpClient.getJsonAsync<string>('EdiSetupField/GetDefaultSql', {fieldName: fieldName }, cancellationToken);
  }
}
